import { forwardRef } from "react";
import { useClickAway } from "react-use";
import { Input } from "../input";
import { InputWrapper } from "../input/input.style";
import { FilterMenuOptionContainer } from "./filter-menu.style";
import { Button } from "../button";

const FilterMenu = forwardRef(
    ({ visible, top, left, right, bottom, }, ref) => {

        // function handleClick(index) {
        //     optionsFns[index]();
        //     onClose();
        // }

        const handleChange = (e) => {
            console.log(e.target.value)
        }

        // useClickAway(ref, () => {
        //     onClose();
        // });

        return (
            <FilterMenuOptionContainer visible={visible} ref={ref} style={{ top, right, left, bottom }}>
                <form>
                    <InputWrapper>
                        <Input
                            label="Organization"
                            id="Organization"
                            type="text"
                            placeholder="Organization"
                            fullWidth
                            onChange={handleChange}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            label="Username"
                            id="username"
                            type="text"
                            placeholder="Username"
                            fullWidth
                            onChange={handleChange}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            label="Email"
                            id="email"
                            type="text"
                            placeholder="Email"
                            fullWidth
                            onChange={handleChange}
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            label="Date"
                            id="date"
                            type="date"
                            placeholder="Date"
                            onChange={handleChange}
                            fullWidth
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            label="Phone Number"
                            id="phoneNumber"
                            type="text"
                            placeholder="Phone Number"
                            onChange={handleChange}
                            fullWidth
                        />
                    </InputWrapper>
                    <InputWrapper>
                        <Input
                            label="Status"
                            id="status"
                            type="text"
                            placeholder="Status"
                            onChange={handleChange}
                            fullWidth
                        />
                    </InputWrapper>
                    <div style={{ display: 'flex', gap: '1.4rem', marginTop: '3rem' }}>
                        <Button
                            variant="outline-secondary"
                            size="medium"
                        >
                            Reset
                        </Button>
                        <Button
                            size="medium"
                        >
                            Filter
                        </Button>
                    </div>
                </form>

            </FilterMenuOptionContainer>
        );
    }
);


export { FilterMenu }